/**************************************************************************************
 * http header常量
 *      注：此处的所有字段名，需与后端保持一致
 *
 * @author Francis
 * @since 2024-03-13 10:37
 * @version 1.0
 ***************************************************************************************/
// timestamp字段
export const timestampField = "Timestamp";
// SM4密钥字段
export const requestKey = "Request-Key";
// 签名字段
export const signatureField = "Signature";
// Authorization字段
export const authorizationField = "Authorization";
// Token字段
export const tokenField = "token";
// 参数加密标识、签名校验标识的flag
export const encryptFlag = "Encrypt-Flag";
// 签名校验-密钥字段
export const signValidateSecretField = "Secret";
// 签名校验-参数字段
export const signValidateParamField = "Param";
// 当前动态资源编号字段
export const resourceIdField = "X-Resource-Id";

